import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { Observable } from "rxjs";
import { tap, mergeMap } from 'rxjs/operators';
import { AuthenticationService } from "./authentication.service";
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';

@Injectable()
export class AuthenticationIntercepter implements HttpInterceptor {

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private adal: MsAdalAngular6Service
    ) {
    }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const resource = this.adal.GetResourceForEndpoint(request.url);
        var app = null;
        if (this.authenticationService.getCurrentUserApplication()) {
            app = this.authenticationService.getCurrentUserApplication()["active_directory_id"];
        }
        return this.adal.acquireToken(resource).pipe(
            mergeMap((token: string) => {

                const authorizedRequest = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                        active_directory_id: app ? app : ''
                    }
                });
                return next.handle(authorizedRequest).pipe(tap(() => { },
                    (err: any) => {
                        if (err instanceof HttpErrorResponse) {
                            if (err.status == 401) {
                                this.authenticationService.logout();
                            }
                        }
                    }));

            }
            ));
    }
}